import { useState } from 'react';
import { useSelector } from 'react-redux';
import { PermissionOption, IUser } from '../../../libraries/user';
import { LoginState } from '../../client-redux/login/reducer';
import { AppState } from '../../client-redux/reducers';
import ModalComponent from '../../components/modal';
import { Language } from '../../languages/languageHandler';
import UserForm, { UserFormMode } from './user-form';
import CustomModal from '../../components/custom-modal';

interface UserModalProps {
  show: boolean;
  mode: UserFormMode;
  user: IUser;
  lang: Language;
  permissionOptions: PermissionOption[];
  onClose: () => void;
  onUserAdded?: () => void;
  OnUserDeleted?: (uid: number) => void;
}

const UserModal = ({
  show,
  mode,
  user,
  lang,
  permissionOptions,
  onClose,
  onUserAdded,
  OnUserDeleted
}: UserModalProps) => {
  const loginInfo = useSelector<AppState, LoginState>(state => state.login);

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [message, setMessage] = useState('');

  const baseUser: IUser = {
    entid: loginInfo.user.entid || 0,
    uid: null,
    lang: loginInfo.user.lang || 0,
    region: loginInfo.user.region || 'Europe/Lisbon'
  };

  return (
    <>
      <ModalComponent
        show={show}
        handleClick={onClose}
        title={mode === UserFormMode.CREATE ? lang.USER_NEW : user.name}
        content={
          <UserForm
            mode={mode}
            isNew={mode === UserFormMode.CREATE}
            user={mode === UserFormMode.CREATE ? baseUser : user}
            lang={lang}
            permissionOptions={permissionOptions}
            togglePermissions={() => {}}
            onSuccess={() => {
              setMessage(
                mode === UserFormMode.CREATE ? lang.ADD_USER_ALERT_UPDATE_SUCCESS : lang.EDIT_USER_ALERT_UPDATE_SUCCESS
              );
              setShowSuccessDialog(true);
              setTimeout(() => {
                setShowSuccessDialog(false);
                onClose();
                onUserAdded?.();
              }, 2000);
            }}
            onError={msg => {
              setMessage(
                (mode === UserFormMode.CREATE ? lang.ADD_USER_ALERT_UPDATE_ERROR : lang.EDIT_USER_ALERT_UPDATE_ERROR) +
                  '\n' +
                  msg
              );
              setShowErrorDialog(true);
              setTimeout(() => setShowErrorDialog(false), 2000);
            }}
            onDelete={() => {
              if (user?.uid != null) {
                OnUserDeleted?.(user.uid);
              }
            }}
          />
        }
      />

      <CustomModal
        opened={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        message={message}
        backgroundColor="#3BDF70"
        textColor="black"
      />

      {/* Error modal */}
      <CustomModal
        opened={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        message={message}
        backgroundColor="#E3353F"
        textColor="white"
      />
    </>
  );
};

export default UserModal;
